import constants from "src/constants";
import translate from "src/functions/translate";

function optionsLocale(
  prop: `language` | `country`,
  lang: string
): { title: string; value: string }[] {
  return Object.keys(constants.Locales)
    .map((keyName) =>
      !keyName.startsWith(`_`)
        ? {
            title: translate(constants.Locales[keyName][prop], lang),
            value:
              prop === `country`
                ? constants.Locales[keyName].territory.toUpperCase()
                : constants.Locales[keyName].lang,
          }
        : undefined
    )
    .filter((n) => n);
}

export default optionsLocale;
